import { CASES_GENERAL_INFORMATION_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useCasesGeneralInformationList } from './hook';
import { CasesGeneralInformationListProps } from './props';

export const CasesGeneralInformationList = ({
    filters,
}: CasesGeneralInformationListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useCasesGeneralInformationList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${CASES_GENERAL_INFORMATION_DETAIL}/${item.row.id}`,
                    '_blank'
                )
            }
        />
    );
};
